<template>
    <v-modal :name="name"
             :pivot-y="0"
             :pivot-x="1"
             :click-to-close="false"
             height="100%"
             :width="width"
             transition="fade-right"
             @before-open="beforeOpen"
             @before-close="beforeClose"
             @opened="opened"
             ref="parentModal"
    >
        <div class="portlet light portlet-modal form" :style="portletStyle">
            <div class="portlet-title">
                <div class="caption">
                    <i class="icon-speech"></i>
                    <span class="caption-subject bold uppercase" v-text="title"></span>
                </div>
                <div class="actions">
                    <a class="btn btn-circle btn-icon-only btn-default" @click="close" data-original-title="Close"
                       title="">
                        <i class="fa fa-close"></i>
                    </a>
                </div>
            </div>
            <div class="portlet-body" :style="bodyStyle">
                <slot></slot>

                <div class="form-actions fixed-bottom">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="text-center">
                                <slot name="actions"></slot>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </v-modal>
</template>

<script>

    export default {
        props: {
            name: {
                type: String,
                required: true
            },
            title: {
                type: String,
                required: true
            },
            forceWidth: {
                type: String,
                default: null
            }
        },

        data() {
            return {
                width: "45%",
                minHeight: 0,
                portletStyle: {
                    height: 'auto',
                    marginTop: 0
                },
                bodyStyle: {
                    height: 'auto',
                    overflowY: 'auto',
                    overflowX: 'hidden',

                }
            }
        },

        methods: {
            beforeOpen(event) {
                this.adjustSize()
                this.$emit('before-open', event)
            },

            opened(event) {
                window.addEventListener('resize', _.debounce(this.adjustSize, 50))
                this.$emit('modal-opened', event)
            },

            beforeClose(event) {
                window.removeEventListener('resize', _.debounce(this.adjustSize, 50))
                this.$emit('before-close', event)
            },

            close() {
                this.$modal.hide(this.name)
                this.$emit('modal-closed')
            },

            adjustSize() {

                this.minHeight = $(window).height()

                if ($(window).width() <= App.getResponsiveBreakpoint('sm')) {
                    this.width = '100%'
                }

                if (!this.forceWidth) {
                    if ($(window).width() > App.getResponsiveBreakpoint('sm') && $(window).width() <= App.getResponsiveBreakpoint('md')) {
                        this.width = '65%'
                    }
                    if ($(window).width() > App.getResponsiveBreakpoint('md')) {
                        this.width = '45%'
                    }
                }

                let portletMarginTop = $(window).width() <= App.getResponsiveBreakpoint('md') ? 0 : 65
                let portletHeight = this.$children[0].trueModalHeight - portletMarginTop
                this.portletStyle.marginTop = portletMarginTop + 'px'
                this.portletStyle.height = portletHeight + 'px'


                let modalTitleHeight = 50
                let modalActionsHeight = 50

                let portletBodyHeight = portletHeight - modalActionsHeight - modalTitleHeight - portletMarginTop

                this.bodyStyle.height = portletBodyHeight + 'px'
            }
        },

        beforeMount() {
            if (this.forceWidth) {
                this.width = this.forceWidth
            }

            // NOT WORKING AS EXPECTED
            // window.addEventListener('keyup', event => {
            //     if (event.which !== 27) {
            //         return;
            //     }
            //
            //     this.close()
            // })
        }
    }

</script>

<style scoped>
    .portlet.portlet-modal {
        padding: 10px 15px !important;
    }

    .portlet.light .portlet-form .form-actions.fixed-bottom,
    .portlet.light .form .form-actions.fixed-bottom {
        position: absolute;
        bottom: 0px;
        right: 20px;
        left: 20px;
        background-color: white;
    }
</style>